// @ts-strict-ignore
import React, { memo, useState } from 'react'
import { IconButton, Tooltip, TextField, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import FocusFadeGroup from 'components/FocusFadeGroup'
import ExternalLink from 'components/ExternalLink'
import { Create } from '@mui/icons-material'
import { FormValue } from 'types'
import FormErrorHint from '../../FormErrorHint'
import useStyles from './styles'

interface ICompanyNameFieldsProps {
  companyName: FormValue<string>
  companyWebsite: FormValue<string>
  editable: boolean
  label?: string
}

function CompanyNameFields(props: ICompanyNameFieldsProps) {
  const { classes } = useStyles()
  const theme = useTheme()
  const { companyName, companyWebsite, editable, label } = props

  const [isEditorOpen, setIsEditorOpen] = useState<boolean>(false)

  const input = companyName?.input

  const closeEditor = () => {
    setIsEditorOpen(false)
  }

  const renderCompanyName = () => {
    if (companyWebsite?.input?.value) {
      return (
        <ExternalLink
          href={companyWebsite?.input?.value}
          label={companyName?.input?.value || (
            <span className={classes.placeholder}>my company</span>
          )}
        />
      )
    }

    return label
  }

  const handleTextAreaBlur = (e) => {
    props.companyName.input.onBlur(e)
    closeEditor()
  }

  const handleDialogOpenToggle = () => {
    if (isEditorOpen) {
      closeEditor()
    } else {
      setIsEditorOpen(true)
    }
  }

  if (!input.value && !editable) {
    return null
  }

  return (
    <FocusFadeGroup focused={isEditorOpen}>
      <Typography variant="h3">
        {!isEditorOpen && (
          <div>
            <div style={{ marginRight: theme.spacing(2), display: 'inline-block' }}>
              About {renderCompanyName()}
            </div>

            {editable && (
              <Tooltip title="Edit this section" placement="right">
                <IconButton onClick={handleDialogOpenToggle} className={classes.iconButton} data-cy={`job-${input.name}-open`}>
                  <Create />
                </IconButton>
              </Tooltip>
            )}
          </div>
        )}

        {isEditorOpen && (
          <div>
            <TextField
              autoFocus
              value={input.value}
              onChange={input.onChange}
              onBlur={handleTextAreaBlur}
              label={label || ''}
              placeholder="Company name"
              className={classes.input}
              data-cy={`job-${input.name}-input`}
            />
          </div>
        )}

        {(!isEditorOpen) && (
          <FormErrorHint message={companyName?.meta?.touched && companyName?.meta?.error} />
        )}
      </Typography>
    </FocusFadeGroup>
  )
}

export default memo(CompanyNameFields)
